<template>
  <div class="conserve-wrapper" >
    <div class="nav" style="height: auto">
      <div class="nav-left">
        <div class="parallelogram-btn-left" style="margin-right: 0.5vw" @click="toPlanSingle">
          <div class="icon-font">&#xe63f;</div>
          <div>养护计划单</div>
        </div>
        <div class="parallelogram-btn-left parallelogram-btn-active">
          <div class="icon-font">&#xe63f;</div>
          <div>养护到期汇总</div>
        </div>
      </div>
      <div class="nav-center">养护到期汇总</div>
      <div class="nav-right">
        <div class="parallelogram-btn-right" :class="change === 1 ? className : ''" style="margin-right: 0.5vw"></div>
        <div class="parallelogram-btn-right" :class="change === 2 ? className : ''" style="margin-right: 0.5vw"></div>
        <div class="parallelogram-btn-right" :class="change === 3 ? className : ''" style="margin-right: 0.5vw"></div>
        <div class="parallelogram-btn-right" :class="change === 4 ? className : ''" style="margin-right: 0.5vw"></div>
        <div class="parallelogram-btn-right" :class="change === 5 ? className : ''" style="margin-right: 0.5vw"></div>
        <div class="parallelogram-btn-right" @click="exportData">
          <div class="icon-font">&#xe601;</div>
          <div>导出表格</div>
        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <div class="inspection-cen" v-if="hide">
        <div class="warn-top">
          <div class="input-wrapper">
            <input v-model="keyword" placeholder="请输入关键字"/>
          </div>
          <div style="margin:0 1vw">
            <DropDown content="请选择养护阶段" :items="maintainStageData" v-on:sendInfo = "showInfoMaintainStag"></DropDown>
          </div>
          <div style="margin-right: 1vw">
            <DropDown content="请选择变更状态" :items="isReplaceData" v-on:sendInfo = "showInfoIsReplace"></DropDown>
          </div>
          <div style="margin-right: 1vw">
            <DropDown content="请选择审核状态" :items="approveStatusData" v-on:sendInfo = "showInfoStatus"></DropDown>
          </div>
          <div class="query" @click="handleSearch(1)">查询</div>
        </div>
        <div class="conserve-summery-box">
          <div class="conserve-summery-box-list">
            <div class="conserve-summery-box-list-num">{{statistics && statistics.stageOne}}</div>
            <div class="conserve-summery-box-list-title">自然醇化</div>
          </div>
          <div class="conserve-summery-box-list">
            <div class="conserve-summery-box-list-num">{{statistics && statistics.stageTwo}}</div>
            <div class="conserve-summery-box-list-title">防霉杀虫</div>
          </div>
          <div class="conserve-summery-box-list">
            <div class="conserve-summery-box-list-num">{{statistics && statistics.stageThree}}</div>
            <div class="conserve-summery-box-list-title">气调醇化</div>
          </div>
          <div class="conserve-summery-box-list">
            <div class="conserve-summery-box-list-num">{{statistics && statistics.stageFour}}</div>
            <div class="conserve-summery-box-list-title">气调保质</div>
          </div>
        </div>
        <div class="inspection-operation" style="padding-top: 1vw">
          <div class="two-font-wrapper" @click="deleteAll"><div class="icon-font">&#xe646;</div>删除</div>
          <div class="four-font-wrapper" @click="toHistory"><div class="icon-font">&#xe600;</div>历史汇总单</div>
        </div>
        <div class="detail">
          <div class="detail-box">
            <div class="loading-data" v-if="loading">
              <i class="el-icon-loading"></i>
              <div>加载中，请稍后···</div>
            </div>
            <div class="detail-nav">
              <div class="detail-item" style="width: 5%">
                <div class="select-icon" :class="{'select-icon-active': all}" @click="selectAll"></div>
              </div>
              <div class="detail-item" style="width: 5%">序号</div>
              <div class="detail-item" style="width: 5%">批次号</div>
              <div class="detail-item" style="width: 15%">烟叶简称</div>
              <div class="detail-item" style="width: 8%">养护阶段</div>
              <div class="detail-item" style="width: 15%">位置</div>
              <div class="detail-item" style="width: 10%">已养护时间</div>
              <div class="detail-item" style="width: 5%">变更状态</div>
              <div class="detail-item" style="width: 10%">审核状态</div>
              <div class="detail-item" style="width: 22%">操作</div>
            </div>
            <div class="detail-content">
              <div class="detail-list-wrapper" v-if="!loading && tableData.length>0" v-for="(data,index) in tableData" :key="index">
                <div class="detail-item" style="width: 5%">
                  <div class="select-icon" :class="{'select-icon-active': data.sign === 1}" @click="selectSingle(data.id)"></div>
                </div>
                <div class="detail-item" style="width: 5%">{{index+1}}</div>
                <div class="detail-item" style="width: 5%">{{data.materialBatchNum}}</div>
                <div class="detail-item" style="width: 15%">{{data.materialName}}</div>
                <div class="detail-item" style="width: 8%">{{getMaintainStageData(data.maintainStage)}}</div>
                <div class="detail-item" style="width: 15%;" v-if="data.siteName.length < 12">
                  {{data.siteName}}
                </div>
                <div class="detail-item" style="width: 15%;display: block" v-if="data.siteName.length >= 12">
                  <el-popover
                    placement="top"
                    title=""
                    trigger="hover"
                    :content="data.siteName">
                    <div class="popover" slot="reference">{{data.siteName}}</div>
                  </el-popover>
                </div>
                <div class="detail-item" style="width: 10%">{{data.alreadyMaintainDays}}</div>
                <div class="detail-item" style="width: 5%">
                  <div class="detail-btn" style="padding: 0.2vw 1vw;" :class="data.isChange ? 'item-apply' : 'item-audit-active' ">{{getIsChange(data.isChange)}}</div>
                </div>
                <div class="detail-item" style="width: 10%" :class="data.approveStatus === 1 ? 'color-green' : data.approveStatus === 2 ? 'color-red' : 'color-set'">{{getApproveStatus(data.approveStatus)}}</div>
                <div class="detail-item" style="width: 22%">
                  <div class="detail-btn item-look" @click="toDueLook(data.id)">查看</div>
                  <div class="detail-btn item-audit" @click="toSingleApproval(data.id)" style="margin: 0 0.5vw" v-if="data.approveStatus === 0">审核</div>
                  <div class="detail-btn item-audit item-audit-active" style="margin: 0 0.5vw" v-if="data.approveStatus === 1 || data.approveStatus === 2">审核</div>
                  <div class="detail-btn item-history" style="margin-right: 0.5vw" @click="toChange(data.id)">变更</div>
                  <div class="detail-btn item-set" style="margin-right: 0.5vw" @click="openUse(data.id)">开垛使用</div>
                  <div class="detail-btn item-delete" @click="deleteSingle(data.id)">删除</div>
                </div>
              </div>
              <div class="none-data" v-if="!loading && tableData.length<1">暂无数据</div>
            </div>
            <div class="page-wrapper" v-if="!loading && total > rows">
              <div class="page-wrapper-left">共{{total}}条数据，每页显示{{rows}}条，当前第{{page}}页</div>
              <div class="page-wrapper-right">
                <div class="page-btn" @click="firstPage">首页</div>
                <div class="page-btn" @click="previousPage">上一页</div>
                <div class="page-btn" @click="nextPage">下一页</div>
                <div class="page-btn" @click="lastPage">尾页</div>
              </div>
            </div>
          </div>
          <transition name="fade">
            <div class="alert-box" v-if="show">
              <div class="alert-content">
                <div class="alert-content-title">{{alertMsg}}提醒</div>
                <div class="alert-content-msg">是否确认{{alertMsg}}选中数据?</div>
                <div class="alert-content-btn">
                  <div class="btn-cancel button" @click="cancelDelete">取消</div>
                  <div class="btn-confirm button" @click="confirmDelete">确认</div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { exportJson } from '../../../vendor/Export2Excel'
import DropDown from '../../../components/DropDownSingle.vue'
import {queryDueMaintainPlan, delMaintainPlan, bathDelMaintainPlan, exportMaintainPlanHistory, stackOpenUse} from '../../../api/maintain'
export default {
  name: 'DueSummery',
  components: { DropDown },
  data () {
    return {
      className: 'parallelogram-btn-right_',
      change: 0,
      useId: '',
      alertMsg: '',
      statistics: '',
      hide: false,
      show: false,
      all: false,
      id: '',
      type: 0,
      idList: [],
      isReplaceData: [
        {name: '全部', value: ''},
        {name: '否', value: 0},
        {name: '是', value: 1}
      ],
      approveStatusData: [
        {name: '全部', value: ''},
        {name: '未审核', value: 0},
        {name: '已审核', value: 1},
        {name: '已拒绝', value: 2}
      ],
      maintainStageData: [
        {name: '全部', value: ''},
        {name: '自然醇化阶段', value: '01'},
        {name: '防霉杀虫阶段', value: '02'},
        {name: '气调醇化阶段', value: '03'},
        {name: '气调保质阶段', value: '04'}
      ],
      loading: true,
      keyword: '',
      approveStatus: '',
      maintainStage: '',
      isReplace: '',
      page: 1,
      rows: 5,
      total: '',
      tableData: []
    }
  },
  created () {
    let _this = this
    setTimeout(function () {
      _this.hide = true
    }, 100)
    let a = 1
    setInterval(function () {
      _this.change = a
      a++
      if (a === 6) {
        a = 1
      }
    }, 1000)
    let b = 0
    setInterval(function () {
      b++
      if (b < 6) {
        _this.className = 'parallelogram-btn-right_'
      } else if (b < 11) {
        _this.className = 'parallelogram-btn-right__'
      } else if (b < 16) {
        _this.className = 'parallelogram-btn-right___'
      } else {
        b = 1
        _this.className = 'parallelogram-btn-right_'
      }
    }, 1000)
    this.handleSearch(1)
  },
  methods: {
    getMaintainStageData: function (maintainStage) {
      if (maintainStage === '01') {
        return '自然醇化阶段'
      } else if (maintainStage === '02') {
        return '防霉杀虫阶段'
      } else if (maintainStage === '03') {
        return '气调醇化阶段'
      } else {
        return '气调保质阶段'
      }
    },
    getApproveStatus: function (approveStatus) {
      if (approveStatus === 0) {
        return '未审核'
      } else if (approveStatus === 1) {
        return '已审核'
      } else if (approveStatus === 2) {
        return '已拒绝'
      }
    },
    getIsChange: function (isChange) {
      if (isChange) {
        return '是'
      } else {
        return '否'
      }
    },
    toPlanSingle: function () {
      this.$router.push({
        path: '/conserve',
        query: {
          index: '8'
        }
      })
    },
    toHistory: function () {
      this.$router.push({
        path: '/conserve/history',
        query: {
          index: '8'
        }
      })
    },
    toChange: function (id) {
      this.$router.push({
        path: '/conserve/change',
        query: {
          index: '8',
          id: id
        }
      })
    },
    toDueLook: function (id) {
      this.$router.push({
        path: '/conserve/dueLook',
        query: {
          index: '8',
          id: id
        }
      })
    },
    toSingleApproval: function (id) {
      this.$router.push({
        path: '/conserve/singleApproval',
        query: {
          index: '8',
          id: id
        }
      })
    },
    openUse: function (id) {
      this.show = true
      this.useId = id
      this.type = 2
      this.alertMsg = '开垛使用'
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    exportData: function () {
      let body = {
        keyword: this.keyword,
        approveStatus: this.approveStatus,
        maintainStage: this.maintainStage,
        isReplace: this.isReplace
      }
      exportMaintainPlanHistory(body).then(res => {
        console.log(res)
        if (res.data) {
          res.data.map(data => {
            data.maintainStage = this.getMaintainStageData(data.maintainStage)
            data.approveStatus = this.getApproveStatus(data.approveStatus)
            data.isChange = this.getIsChange(data.isChange)
          })
          require.ensure([], () => {
            const tHeader = ['批次号', '烟叶简称', '养护阶段', '位置', '计划养护时间', '审核状态', '变更状态']
            const filterVal = ['materialBatchNum', 'materialName', 'maintainStage', 'siteName', 'maintainDays', 'approveStatus', 'isChange']
            const list = res.data
            const data = this.formatJson(filterVal, list)
            exportJson(tHeader, data, '养护到期汇总')
            this.$message({
              message: '导出成功!',
              type: 'success',
              center: 'true',
              duration: 1000
            })
          })
        } else {
          this.$message({
            message: '暂无数据可导出!',
            type: 'warning',
            center: 'true',
            duration: 1000
          })
        }
      }).catch(err => {
        console.log(err)
        this.$message({
          message: '导出失败!',
          type: 'warning',
          center: 'true',
          duration: 1000
        })
      })
    },
    handleSearch: function (type) {
      if (type === 1) {
        this.page = 1
      }
      let body = {
        page: this.page,
        rows: this.rows,
        keyword: this.keyword,
        approveStatus: this.approveStatus,
        maintainStage: this.maintainStage,
        isReplace: this.isReplace
      }
      this.loading = true
      queryDueMaintainPlan(body).then(res => {
        console.log(res)
        this.statistics = res.data.statistics
        res.data.pageList.rows && res.data.pageList.rows.map(item => {
          item.sign = 0
        })
        this.tableData = res.data.pageList.rows || []
        this.total = res.data.pageList.total
        this.loading = false
      }).catch(err => {
        console.log(err)
      })
    },
    showInfoIsReplace: function (data) {
      this.isReplace = data.value
    },
    showInfoStatus: function (data) {
      this.approveStatus = data.value
    },
    showInfoMaintainStag: function (data) {
      this.maintainStage = data.value
    },
    selectAll: function () {
      this.type = 1
      this.all = !this.all
      let idList = []
      if (this.all) {
        this.tableData.map((data, index) => {
          data.sign = 1
          idList.push(data.id)
        })
        this.idList = idList
      } else {
        this.tableData.map((data, index) => {
          data.sign = 0
          this.idList = []
        })
      }
    },
    selectSingle: function (id) {
      this.tableData.map((data, index) => {
        if (id === data.id) {
          data.sign = data.sign === 1 ? 0 : 1
          if (data.sign === 1) {
            this.idList.push(data.id)
          } else {
            let idList = []
            this.idList.map((item, index) => {
              if (item !== id) {
                idList.push(item)
              }
            })
            this.idList = idList
          }
          console.log(this.idList)
        }
      })
      this.all = this.idList.length === this.tableData.length
    },
    deleteSingle: function (id) {
      this.show = true
      this.id = id
      this.type = 0
      this.alertMsg = '删除'
    },
    deleteAll: function () {
      if (this.idList.length !== 0) {
        this.show = true
        this.type = 1
        this.alertMsg = '删除'
      } else {
        this.$message({
          message: '请选择要删除的数据!',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
      console.log(this.idList)
    },
    cancelDelete: function () {
      this.show = false
    },
    confirmDelete: function () {
      if (this.type === 0) {
        console.log(this.id)
        let body = {
          id: this.id
        }
        delMaintainPlan(body).then(res => {
          console.log(res)
          if (res.code === 200) {
            this.$message({
              message: res.data,
              type: 'success',
              center: 'true',
              duration: '1000'
            })
            this.show = false
            this.handleSearch()
          } else {
            this.$message({
              message: res.message,
              type: 'warning',
              center: 'true',
              duration: '1000'
            })
            this.show = false
          }
        }).catch(err => {
          console.log(err)
        })
      } else if (this.type === 1) {
        console.log(this.idList)
        let body = {
          idArray: this.idList.join()
        }
        bathDelMaintainPlan(body).then(res => {
          console.log(res)
          if (res.code === 200) {
            this.$message({
              message: res.data,
              type: 'success',
              center: 'true',
              duration: '1000'
            })
            this.show = false
            this.handleSearch()
          } else {
            this.$message({
              message: res.message,
              type: 'warning',
              center: 'true',
              duration: '1000'
            })
            this.show = false
          }
        }).catch(err => {
          console.log(err)
        })
      } else if (this.type === 2) {
        let body = {
          id: this.useId
        }
        stackOpenUse(body).then(res => {
          console.log(res)
          if (res.code === 200) {
            this.$message({
              message: res.data,
              type: 'success',
              center: 'true',
              duration: '1000'
            })
            this.show = false
            this.handleSearch()
          } else {
            this.$message({
              message: res.message,
              type: 'warning',
              center: 'true',
              duration: '2000'
            })
            this.show = false
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    firstPage: function () {
      console.log('首页')
      if (this.page === 1) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page = 1
        this.handleSearch()
      }
    },
    previousPage: function () {
      console.log('上一页')
      if (this.page < 2) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page--
        this.handleSearch()
      }
    },
    nextPage: function () {
      console.log('下一页')
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++
        this.handleSearch()
      } else {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
    },
    lastPage: function () {
      console.log('尾页')
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows)
        } else {
          this.page = parseInt(this.total / this.rows) + 1
        }
        this.handleSearch()
      }
    }
  }
}
</script>

<style scoped>
@import "Conserve.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/conserve/DueSummery.vue